/**
 * Created by calhosh on 7/16/2017.
 */

import {useEffect} from 'react';
import _ from 'lodash';
import {labels, currentResource} from '../../../util/utils';
import Utility from '../../../util/utilityfunctions';
import {useDispatch, useSelector} from 'react-redux';
import {clearErrors} from '../../../actions/erroractions';
import {setFormV2ToasterVisibility} from '../../../actions/Toast/toastactions';
import ErrorsUtility from './index';

export default function Errors() {
	const errors = useSelector((store) => store.errors);
	const isModalOpen = useSelector((state) => state.isModalOpen);

	const dispatch = useDispatch();

	const clearError = () => {
		dispatch(clearErrors());
	};

	const addNotification = (level, message, autoDismissInSeconds) => {
		!isModalOpen &&
			dispatch(
				setFormV2ToasterVisibility(true, level, Utility.createRichTextElement(message), '', autoDismissInSeconds)
			);
	};

	useEffect(() => {
		!_.isEmpty(errors) ? clearError() : null;
		ErrorsUtility.addNotification(errors, addNotification);
	}, [errors]);
}
